import React from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import { theme } from 'global'
import { Box } from '../Box/Box'
import {
  ToggleContent,
  IToggleEvents,
} from 'components/ToggleContent/ToggleContent'

const ModalContainer = styled(Box)`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  background-color: white;
  z-index: ${theme.zIndices.modal};
`

export interface IModalChildrenProps<T = any> {
  show: IToggleEvents<T>['show']
}
export interface IModalContentProps<T = any> {
  hide: IToggleEvents<T>['hide']
}

export interface IModalCallbacks<T = any>
  extends Pick<IToggleEvents<T>, 'onOpen' | 'onClose'> {}

interface IModal extends IModalCallbacks {
  children: (props: IModalChildrenProps) => React.ReactNode
  content: (props: IModalContentProps) => React.ReactNode
}

export const Modal = ({ children, content, ...props }: IModal) => {
  const element = document.getElementById('root')
  return (
    element && (
      <ToggleContent
        toggle={children}
        content={contentProps =>
          ReactDOM.createPortal(
            <ModalContainer>{content(contentProps)}</ModalContainer>,
            element
          )
        }
        {...props}
      />
    )
  )
}
